import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  deviceSelection: {
    gridArea: "deviceSelection",
    display: "flex",
    alignItems: "flex-start",
    "& .MuiBox-root": {
      flexDirection: "column",
      alignItems: "flex-start",
      width: "100%",
      "& .MuiFormControl-root": {
        maxWidth: "100%",
      },
    },
  },
  selectorRow: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  testAudioButton: {
    textDecoration: "underline",
    color: theme.palette.events.bluePrimary,
    fontWeight: 400,
  },
}));
